import { Icon as IconifyIcon } from '@iconify/react'
import { useGet, useSet } from 'ccstate-react'
import { sharedLocationState } from '../state'
import { navigateInReact$ } from '../infra/router/navigate'
export default function TabBar() {
  const currentPath = useGet(sharedLocationState.pathname$)
  const navigate = useSet(navigateInReact$)
  const tabs = [
    { path: '/', label: '查词', icon: 'lucide:search' },
    { path: '/history', label: '历史', icon: 'lucide:clock' },
    { path: '/favorites', label: '收藏', icon: 'lucide:star' }
  ]
  return (<div className="fixed bottom-0 left-0 right-0 bg-[#F7F8FA] border-t-2 border-[#D4DBE6]" data-id="464qqv">
    <div className="flex justify-around items-center h-16 max-w-[390px] mx-auto" data-id="9askxu">
      {tabs.map((tab, index) => {
        const isActive = currentPath === tab.path
        return (<button key={tab.path} onClick={() => navigate(tab.path as '/' | '/history' | '/favorites')} className={`flex flex-col items-center justify-center flex-1 h-full relative ${index !== tabs.length - 1 ? 'border-r border-[#E8EDF3]' : ''}`} data-testid={`tab-${tab.label}`} data-id="862pwo">
          <IconifyIcon icon={tab.icon} className={`text-2xl mb-1 ${isActive ? 'text-[#1E3A5F]' : 'text-[#9BA8B8]'}`} data-id="pmhupu"/>
          <span className={`text-xs ${isActive ? 'text-[#1E3A5F] font-semibold' : 'text-[#9BA8B8]'}`} data-id="lq39mh">
            {tab.label}
          </span>
          {isActive && <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#1E3A5F]" data-id="h1telv"></div>}
        </button>)
      })}
    </div>
  </div>)
}
